/**
 * .banner__boxをループ
 * 画面サイズ749px以下でdata-color-schemaの値をクラスに付与
 * 画面サイズ750px以上でdata-pc-color-schemaの値をクラスに付与
 */
let mobile;
const $boxes = document.querySelectorAll('.banner__box');

function updateBannerBoxColorSchema() {
  const isMobile = window.innerWidth <= 749;
  if(isMobile !== mobile) {
    mobile = isMobile;
    $boxes.forEach(box => {
      box.classList.remove(
          box.dataset.colorSchema,
          box.dataset.pcColorSchema
      );
      if (isMobile) {
        if (box.dataset.colorSchema) {
          box.classList.add(box.dataset.colorSchema);
        }
      } else {
        if (box.dataset.pcColorSchema) {
          box.classList.add(box.dataset.pcColorSchema);
        }
      }
    });
  }
}
window.addEventListener('resize', updateBannerBoxColorSchema);
document.addEventListener('DOMContentLoaded', updateBannerBoxColorSchema);